import axios from "axios";
import { api } from "../../utils/api";
import { request } from "../../utils/request";
import { Navigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { LocksmithDetailType, LocksmithFieldType } from "../../utils/types";
import Spinner from "../../components/spinner";
import LocksmithForm from "../../components/locksmith-form";
import LocksmithNotFound from "../../components/locksmith-not-found";

export default function EditLocksmith() {
    const params = useParams();
    const id = Number(params.id);
    const isValidId = !Number.isNaN(id)
    const [detail, setDetail] = useState<LocksmithFieldType>();
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        if (!isValidId) return;
        setLoading(true)
        fetchDetails(id).then((data: LocksmithDetailType) => {
            setLoading(false)
            if (!data) return;
            const editableLocksmithDetail: LocksmithFieldType = {
                contact_number: data.locksmith.contact_number,
                email: data.email,
                full_name: data.full_name,
                password: '',
                locksmith_color: data.locksmith.locksmith_color
            }
            setDetail(editableLocksmithDetail)
        })
    }, [id, isValidId]);

    return <div className="w-full md:p-0 p-3">
        <div className="flex w-full items-center justify-between">
            <h1 className={`text-2xl`}>Edit Locksmith</h1>
            {loading && <div className="absolute w-96 h-96 items-center justify-center flex"><Spinner /></div>}
        </div>
        <div className="mt-5 pl-5 pr-5">
            {!isValidId ? <Navigate to={'/404'} replace />
                : (!loading && !detail)
                    ? <LocksmithNotFound />
                    : <LocksmithForm id={id} loading={loading} defaultValues={detail} />}
        </div>
    </div>
}


const fetchDetails = async (id: number) => {
    try {
        const response = await request('GET', api.locksmith.detail + id);
        return response.data.data
    } catch (error) {
        if (axios.isAxiosError(error)) {
            if (error.status !== 400) throw error;
        }
    }
}
